import { ModulePermissions } from "types";

export const subscriptions: ModulePermissions = {
  subscriptions: {
    Admin: {},
  }, nonSubscribers: {
    Admin: {},
  },
};
